/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1742774400000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Mon Mar 24 2025 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "iterable",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Iterable",
          "depth": 0,
          "id": "connect-to-iterable"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing users",
          "depth": 1,
          "id": "syncing-users"
        }, {
          "value": "Syncing events",
          "depth": 1,
          "id": "syncing-events"
        }, {
          "value": "Updating shopping cart items",
          "depth": 1,
          "id": "updating-shopping-cart-items"
        }, {
          "value": "Syncing catalogs",
          "depth": 1,
          "id": "syncing-catalogs"
        }, {
          "value": "Syncing segments",
          "depth": 1,
          "id": "syncing-segments"
        }, {
          "value": "Subscribing users",
          "depth": 1,
          "id": "subscribing-users"
        }, {
          "value": "Trigger email",
          "depth": 1,
          "id": "trigger-email"
        }, {
          "value": "Trigger push",
          "depth": 1,
          "id": "trigger-push"
        }, {
          "value": "Register device tokens",
          "depth": 1,
          "id": "register-device-tokens"
        }, {
          "value": "Updating user email addresses",
          "depth": 1,
          "id": "updating-user-email-addresses"
        }, {
          "value": "User API actions",
          "depth": 1,
          "id": "user-api-actions"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Unset project identifier",
          "depth": 1,
          "id": "unset-project-identifier"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      p: "p",
      img: "img",
      h3: "h3",
      h4: "h4",
      em: "em",
      code: "code",
      pre: "pre",
      span: "span",
      ul: "ul",
      li: "li"
    }, _provideComponents(), props.components), {CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Users"
              })
            }), _jsx(_components.td, {
              children: "Sync data from any source to your Iterable users"
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#users_bulkUpdateUser",
                children: "User docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Events"
              })
            }), _jsx(_components.td, {
              children: "Sync records as events to Iterable. This is often in the form of a track call."
            }), _jsx(_components.td, {
              children: "Upsert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#events_track",
                children: "Event docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "User shopping cart items"
              })
            }), _jsx(_components.td, {
              children: "Update a user's shopping cart and create an event for it"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#commerce_updateCart",
                children: "Commerce docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Catalog items"
              })
            }), _jsx(_components.td, {
              children: "Sync records as catalog items in Iterable."
            }), _jsx(_components.td, {
              children: "Upsert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#catalogs_partialUpdateCatalogItem",
                children: "Catalog docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Static list"
              })
            }), _jsx(_components.td, {
              children: "Subscribe and unsubscribe users from lists"
            }), _jsx(_components.td, {
              children: "Add, Remove"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#lists_subscribe",
                children: "List docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Update email address"
              })
            }), _jsx(_components.td, {
              children: "Update a user's email address"
            }), _jsx(_components.td, {
              children: "Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#users_updateEmail",
                children: "User email update docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Other user actions"
              })
            }), _jsx(_components.td, {
              children: "Perform API actions like delete, forget and unforget users."
            }), _jsx(_components.td, {
              children: "--"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#users_delete",
                children: "User docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Subscriptions"
              })
            }), _jsx(_components.td, {
              children: "Subscribe and unsubscribe users from lists, message types and message channels"
            }), _jsx(_components.td, {
              children: "Upsert, Remove"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#subscriptions_Bulk_subscription_action",
                children: "Subscription docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Trigger email"
              })
            }), _jsx(_components.td, {
              children: "Send an email to a user"
            }), _jsx(_components.td, {
              children: "--"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "http://api.iterable.com/api/docs#email_target",
                children: "Email docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Trigger push"
              })
            }), _jsx(_components.td, {
              children: "Send a push to a user"
            }), _jsx(_components.td, {
              children: "--"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#push_target",
                children: "Push notification docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Register device tokens"
              })
            }), _jsx(_components.td, {
              children: "Register a device to a user using a token"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://api.iterable.com/api/docs#users_registerDeviceToken",
                children: "Device token docs"
              })
            })]
          })]
        })]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-iterable",
        children: "Connect to Iterable"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Iterable"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to Iterable with an Iterable ", _jsx(_components.strong, {
          children: "API key"
        }), " and ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/9216719179796#checking-the-unique-identifier-for-a-project",
          children: _jsx(_components.strong, {
            children: "Project Type Identifier"
          })
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["You can follow ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/360043464871-API-Keys-#creating-api-keys",
          children: "Iterable's instructions"
        }), " for how to create an API key. Your API key needs to have ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/360043464871-API-Keys-#server-side-keys",
          children: "server-side permissions"
        }), " for all sync types above, except for ", _jsx(_components.strong, {
          children: "Register device tokens"
        }), " which needs to have ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/360043464871-API-Keys#client-side-keys",
          children: "mobile client-side permissions"
        }), ". Hightouch does not support mobile client-side permissions using JSON web tokens (JWT)."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-iterable-api-key.png",
          alt: "API creation in Iterable"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["To see your project type identifier, go to ", _jsx(_components.strong, {
          children: "Settings > Project Settings"
        }), " and see the identifier(s) underneath the project's cluster ID."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-iterable-project-identifier.png",
          alt: "Iterable Project Identifer"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Check out Iterable's ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/9216719179796#checking-the-unique-identifier-for-a-project",
          children: "docs"
        }), " for more information."]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Iterable destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Iterable destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-users",
        children: "Syncing users"
      }), "\n", _jsx(_components.p, {
        children: "Sync Iterable users and user properties with data from any source."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["You can either use ", _jsx(_components.strong, {
          children: "email"
        }), " or ", _jsx(_components.strong, {
          children: "user ID"
        }), " to match rows from your model to users in Iterable.\nIn general, it's best to select the one that corresponds to the ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/9216719179796",
          children: "project type"
        }), " you selected when first setting up your Iterable instance."]
      }), "\n", _jsxs(_components.p, {
        children: ["There's one exception when you ", _jsx(_components.em, {
          children: "shouldn't"
        }), " match your record matching column to your project type:\nIf you have an ", _jsx(_components.strong, {
          children: "email-based"
        }), " Iterable project and you're using ", _jsx(_components.strong, {
          children: "update"
        }), " mode, selecting ", _jsx(_components.strong, {
          children: "user ID"
        }), " for record matching can increase sync speed."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-iterable-user-id-record-matching.png",
          alt: "Selecting User ID for record matching"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["You should do this if you're confident that your user IDs are unique. (In email-based projects, Iterable doesn't require uniqueness for user IDs.)\nEnsure you ", _jsx(_components.a, {
          href: "#unset-project-identifier",
          children: "set your project identifier"
        }), " appropriately."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-iterable-email-based-project.png",
          alt: "Email-based project in destination configuration"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you select user ID for record matching in email-based projects, Hightouch uses the ", _jsx(_components.a, {
          href: "https://api.iterable.com/api/docs#users_bulkUpdateUser",
          children: "bulk user update endpoint"
        }), " with the ", _jsx(_components.code, {
          children: "preferUserId"
        }), " parameter.\nThe ", _jsx(_components.code, {
          children: "preferUserId"
        }), " parameter dictates whether new users should be created if the request includes a ", _jsx(_components.code, {
          children: "userId"
        }), " that doesn't yet exist in the Iterable project.\nThis allows Hightouch to update only existing users without first having to perform a ", _jsx(_components.a, {
          href: "https://api.iterable.com/api/docs#users_getUserById_0",
          children: "lookup"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["Iterable only respects the ", _jsx(_components.code, {
          children: "preferUserId"
        }), " parameter in API calls for email-based projects.\nFor more information on how Iterable's API works differently according to project-type, refer to ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/9216719179796#email-based-projects",
          children: "Iterable's docs"
        }), "."]
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "Upsert"
          }), " mode is performant regardless of the project-type and column used for record matching."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can sync columns from your model to Iterable user's data fields. If you send data for a custom field that doesn't exist, Hightouch adds the field and automatically detects its type."
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["When creating new fields, Iterable automatically generates a schema for that field based on the first data sent.\nYou cannot change the schema once it's set. See ", _jsx(_components.a, {
            href: "https://support.iterable.com/hc/en-us/articles/206430145-User-Profile-Fields-#data-types-for-user-profile-fields",
            children: "Iterable's article"
          }), " for more information."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "nested-objects-and-object-arrays",
        children: "Nested objects and object arrays"
      }), "\n", _jsxs(_components.p, {
        children: ["Iterable supports user and event fields containing ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/208183076-Field-Data-Types#objects",
          children: "JSON objects"
        }), " or ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/208183076-Field-Data-Types#arrays",
          children: "arrays of objects"
        }), ".\nThese objects and object arrays are commonly used to support \"entities\" related to each user—for example, devices, medications, pets, etc.—especially when marketing communication needs to include metadata about these related entities."]
      }), "\n", _jsxs(_components.p, {
        children: ["For example, say you want to sync an array of a customer's pets to be an attribute named ", _jsx(_components.code, {
          children: "pets"
        }), " in Iterable:"]
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-json",
          children: [_jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), "\n    ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"email\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"docs@hightouch.com\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n    ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"dataFields\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), "\n        ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"pets\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "["
          }), "\n          ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"name\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Nacho\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"color\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Ginger\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"age\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-number",
            children: "1"
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"favoriteToy\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Fuzzy spring\""
          }), "\n          ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n          ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"name\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Rami\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"color\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Brown Tabby\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"age\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-number",
            children: "2"
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"favoriteToy\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), " ", _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Feather wand\""
          }), "\n          ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n        ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "]"
          }), "\n    ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n"]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch's ", _jsx(_components.a, {
          href: "/syncs/mapping-data#inline-mapping",
          children: "inline mapper"
        }), " is purpose-built to create nested JSON objects and arrays like this.\nRefer to the ", _jsx(_components.a, {
          href: "/syncs/mapping-data#required-data-format",
          children: "data format requirements"
        }), " and ", _jsx(_components.a, {
          href: "/syncs/mapping-data#create-an-array",
          children: "array creation"
        }), " instructions for details."]
      }), "\n", _jsx(_components.h4, {
        id: "delete-behavior",
        children: "Delete behavior"
      }), "\n", _jsx(_components.p, {
        children: "You have these options for how to treat records that leave your model's query results:"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Do nothing"
              })
            }), _jsx(_components.td, {
              children: "Keep the users in Iterable unchanged"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Clear"
              })
            }), _jsx(_components.td, {
              children: "Keep the user in Iterable and clear data fields managed by Hightouch"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Delete"
              })
            }), _jsx(_components.td, {
              children: "Delete the user from Iterable"
            })]
          })]
        })]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-events",
        children: "Syncing events"
      }), "\n", _jsxs(_components.p, {
        children: ["The integration lets you sync ", _jsx(_components.a, {
          href: "https://api.iterable.com/api/docs#commerce_trackPurchase",
          children: "custom events"
        }), ", ", _jsx(_components.a, {
          href: "https://api.iterable.com/api/docs#commerce_trackPurchase",
          children: "purchase events"
        }), ", and ", _jsx(_components.code, {
          children: "updateCart"
        }), " events to Iterable.\nThis section describes custom and purchase events. Skip to the ", _jsx(_components.a, {
          href: "#updating-shopping-cart-items-events",
          children: "syncing update shopping cart items events"
        }), " for more information on this sync type."]
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing custom and purchase events, the integration inserts new events into Iterable and lets you modify existing events as long as you ", _jsx(_components.a, {
          href: "#additional-track-configuration",
          children: "provide their event ID"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "event-name",
        children: "Event name"
      }), "\n", _jsxs(_components.p, {
        children: ["Providing an event name is required to send an event to the Iterable API.\nYou can either provide a static value or select to ", _jsx(_components.strong, {
          children: "use a column"
        }), " from your model.\nHightouch syncs the static or column value as the ", _jsxs(_components.a, {
          href: "https://api.iterable.com/api/docs#events_trackBulk",
          children: [_jsx(_components.code, {
            children: "eventName"
          }), " body parameter"]
        }), " the API requires."]
      }), "\n", _jsx(_components.h4, {
        id: "event-timestamp",
        children: "Event timestamp"
      }), "\n", _jsx(_components.p, {
        children: "You can optionally select a column that contains timestamps of when events occurred.\nIf this field is empty, Iterable uses the time the event arrives at the server."
      }), "\n", _jsx(_components.h4, {
        id: "additional-track-configuration",
        children: "Additional track configuration"
      }), "\n", _jsx(_components.p, {
        children: "You can also optionally include this information as part of your event information:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Name of the campaign associated with the event: choose a static value or select to ", _jsx(_components.strong, {
            children: "use a column"
          }), " from your model."]
        }), "\n", _jsxs(_components.li, {
          children: ["Event template: choose a static value or select to ", _jsx(_components.strong, {
            children: "use a column"
          }), " from your model."]
        }), "\n", _jsxs(_components.li, {
          children: ["Event ID: select a column from your model. You ", _jsx(_components.strong, {
            children: "must"
          }), " include this configuration if you want to modify existing events."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "If you don't select a column from your model to map as the event ID,\nHightouch considers it a new event and Iterable generates a new event ID."
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["You can use field mapping to add context to your events.\nYou must include either an ", _jsx(_components.strong, {
          children: "email"
        }), " or ", _jsx(_components.strong, {
          children: "user ID"
        }), " in your mappings.\nWhich you include depends on ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/articles/204780579#identifying-users",
          children: "how your project identifies users"
        }), ".\nIf you provide both email and user ID, your project type takes precedence.\nThe integration uses these fields for identifying the user associated with this event."]
      }), "\n", _jsxs(_components.p, {
        children: ["For purchase events, you also need to provide the shopping cart items as ", _jsx(_components.strong, {
          children: "Items"
        }), " and the ", _jsx(_components.strong, {
          children: "Total"
        }), " order dollar amount in your mappings."]
      }), "\n", _jsxs(_components.p, {
        children: ["You can also include event data fields, including custom ones. Hightouch sends any custom fields you include as part of the in the ", _jsx(_components.code, {
          children: "dataFields"
        }), " property of event's body."]
      }), "\n", _jsx(_components.h3, {
        id: "updating-shopping-cart-items",
        children: "Updating shopping cart items"
      }), "\n", _jsxs(_components.p, {
        children: ["This sync mode both updates the ", _jsx(_components.a, {
          href: "https://api.iterable.com/api/docs#commerce_updateCart",
          children: _jsx(_components.code, {
            children: "shoppingCartItems"
          })
        }), " field on a user's profile and tracks ", _jsx(_components.code, {
          children: "updateCart"
        }), " events in Iterable.\nThe integration inserts new events into Iterable when they first appear in your query results."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-2",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["You must include shopping cart items as ", _jsx(_components.strong, {
          children: "Items"
        }), " and either an ", _jsx(_components.strong, {
          children: "email"
        }), " or ", _jsx(_components.strong, {
          children: "user ID"
        }), " in your mappings.\nWhich you include depends on ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/articles/204780579#identifying-users",
          children: "how your project identifies users"
        }), ".\nIf you provide both email and user ID, your project type takes precedence.\nThe integration uses these fields for identifying the user associated with this event."]
      }), "\n", _jsx(_components.p, {
        children: "You can also include user data fields for the user who updated their cart."
      }), "\n", _jsx(_components.h3, {
        id: "syncing-catalogs",
        children: "Syncing catalogs"
      }), "\n", _jsxs(_components.p, {
        children: ["You can keep your Iterable catalogs up-to-date with ", _jsx(_components.strong, {
          children: "Upsert"
        }), " mode.\nBegin by selecting the Iterable catalog you want to sync items to."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-1",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to catalog items, you need to select the model column that contains values that match the ", _jsx(_components.strong, {
          children: "Unique Product ID"
        }), " field.\nRefer to the ", _jsx(_components.a, {
          href: "/syncs/record-matching",
          children: "record matching docs"
        }), " for more information."]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["The Unique Product ID must contain only alphanumeric characters and dashes and has a maximum length of 255 characters.\nSee Iterable's ", _jsx(_components.a, {
            href: "https://api.iterable.com/api/docs#catalogs_bulkUpdateCatalogItems",
            children: "API documentation"
          }), " for more information."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-3",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "Once you've selected a catalog, Hightouch automatically pulls existing fields from your Iterable catalog for you to map data into."
      }), "\n", _jsx(_components.h4, {
        id: "delete-behavior-1",
        children: "Delete behavior"
      }), "\n", _jsx(_components.p, {
        children: "You have these options for how to treat records that leave your model's query results:"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Do nothing"
              })
            }), _jsx(_components.td, {
              children: "Keep the catalog items in Iterable unchanged"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Delete"
              })
            }), _jsx(_components.td, {
              children: "Delete the catalog item in Iterable"
            })]
          })]
        })]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-segments",
        children: "Syncing segments"
      }), "\n", _jsxs(_components.p, {
        children: ["Sync audiences into your Iterable ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/204780549-Static-and-Dynamic-Lists-Overview-",
          children: "static lists"
        }), " of users. Hightouch automatically removes users from the Iterable list when they leave the query result."]
      }), "\n", _jsx(_components.h4, {
        id: "user-identifers",
        children: "User identifers"
      }), "\n", _jsxs(_components.p, {
        children: ["To identify which contacts to add or update in a segment, select a model column and the corresponding Iterable field.\nYou can match on either ", _jsx(_components.strong, {
          children: "Email"
        }), " or ", _jsx(_components.strong, {
          children: "User ID"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["It's best to select the one that corresponds to the ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/9216719179796",
          children: "project type"
        }), " you selected when first setting up your Iterable instance.\nIf you provide both email and user ID, your project type takes precedence."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-4",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can sync columns from your model to user's default and custom data fields.\nIf you send data for a custom field that doesn't exist, Hightouch adds the field and automatically detects its type."
      }), "\n", _jsx(_components.h4, {
        id: "create-or-use-an-existing-list",
        children: "Create or use an existing list"
      }), "\n", _jsx(_components.p, {
        children: "Your can create a new list or select an existing one.\nIf you choose to create a new list, Hightouch creates it on the initial sync run and then keeps it updated on existing sync runs."
      }), "\n", _jsx(_components.p, {
        children: "You can provide a name for the new list, or Hightouch defaults to the name of the model used to create the sync."
      }), "\n", _jsx(_components.h3, {
        id: "subscribing-users",
        children: "Subscribing users"
      }), "\n", _jsx(_components.p, {
        children: "Set all existing users from a query to be subscribed to a specific list, message type or message channel.\nHightouch automatically unsubscribes users from the target when they leave the query result."
      }), "\n", _jsx(_components.h3, {
        id: "trigger-email",
        children: "Trigger email"
      }), "\n", _jsx(_components.p, {
        children: "Send an email to a user. Use an existing campaign that is triggerable and running."
      }), "\n", _jsx(_components.h3, {
        id: "trigger-push",
        children: "Trigger push"
      }), "\n", _jsx(_components.p, {
        children: "Send a push notification to a user. Use an existing campaign that is triggerable and running."
      }), "\n", _jsx(_components.h3, {
        id: "register-device-tokens",
        children: "Register device tokens"
      }), "\n", _jsxs(_components.p, {
        children: ["Register mobile device tokens to enable push notifications. Use either ", _jsx(_components.code, {
          children: "email"
        }), " or ", _jsx(_components.code, {
          children: "userId"
        }), " (but not both) and a ", _jsx(_components.code, {
          children: "device"
        }), "\nobject that contains a valid ", _jsx(_components.code, {
          children: "token"
        }), ", ", _jsx(_components.code, {
          children: "platform"
        }), " and ", _jsx(_components.code, {
          children: "applicationName"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "user-identifers-1",
        children: "User identifers"
      }), "\n", _jsxs(_components.p, {
        children: ["To identify which contacts to add or update in a segment, select a model column and the corresponding Iterable field.\nYou can match on either ", _jsx(_components.strong, {
          children: "Email"
        }), " or ", _jsx(_components.strong, {
          children: "User ID"
        }), ", regardless of your project type."]
      }), "\n", _jsx(_components.h3, {
        id: "updating-user-email-addresses",
        children: "Updating user email addresses"
      }), "\n", _jsxs(_components.p, {
        children: ["Use this sync mode to update existing users' email addresses in ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/articles/9216719179796",
          children: "email-based projects"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["To update an ", _jsx(_components.code, {
          children: "email"
        }), " in a userID-based or hybrid project, use the ", _jsx(_components.a, {
          href: "#syncing-users",
          children: "user sync"
        }), " type."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-2",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["You can use either ", _jsx(_components.strong, {
          children: "email"
        }), " or ", _jsx(_components.strong, {
          children: "user ID"
        }), " to match rows from your model to users in Iterable, regardless of your Iterable project type.\nIf you match by email, the update call is only made the first time the record appears in your query results.\nMatching by user ID updates the email the first time the record appears in your query results and every time changes are detected."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-5",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["The only field you can include in field mapping is the new email.\nIf you want to update other user data fields, use the ", _jsx(_components.a, {
          href: "#syncing-users",
          children: "user sync type"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "user-api-actions",
        children: "User API actions"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch lets you perform the following actions on your Iterable users:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.iterable.com/hc/en-us/articles/360029174171-Responding-to-GDPR-Requests-#deleting-users",
            children: "Delete"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.iterable.com/hc/en-us/articles/360029174171-Responding-to-GDPR-Requests-#forgetting-users",
            children: "Forget"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://support.iterable.com/hc/en-us/articles/360029174171-Responding-to-GDPR-Requests-#unforgetting-users",
            children: "Unforget"
          })
        }), "\n"]
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["This destination only triggers delete, forget, or unforget when records ", _jsx(_components.em, {
            children: "first"
          }), " appear in your model.\nIn other words, if a row with the same ", _jsx(_components.a, {
            href: "/getting-started/concepts#unique-primary-key-requirement",
            children: "primary key"
          }), " appears in the model's query results in multiple syncs, Hightouch only triggers the selected API action on it the first time."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-3",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["You can either use ", _jsx(_components.strong, {
          children: "email"
        }), " or ", _jsx(_components.strong, {
          children: "user ID"
        }), " to match rows from your model to users in Iterable.\nIt's best to select the one that corresponds to the ", _jsx(_components.a, {
          href: "https://support.iterable.com/hc/en-us/articles/9216719179796",
          children: "project type"
        }), " you selected when first setting up your Iterable instance."]
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "unset-project-identifier",
        children: "Unset project identifier"
      }), "\n", _jsxs(_components.p, {
        children: ["Before March 2023, Hightouch didn't require you to set your Iterable project identifier ", _jsx(_components.a, {
          href: "#connect-to-iterable",
          children: "when connecting to Iterable"
        }), ".\nSetting it may enhance sync performance if you're using ", _jsx(_components.strong, {
          children: "update"
        }), " mode with the ", _jsx(_components.strong, {
          children: "users"
        }), " sync type for an email-based project.\nSee the ", _jsx(_components.a, {
          href: "#record-matching",
          children: "record matching section"
        }), " for more information."]
      }), "\n", _jsx(_components.p, {
        children: "You can set the project-type from the configuration tab of your Iterable destination in Hightouch."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-iterable-project-type.png",
          alt: "Project type setting"
        })
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", _jsx(_components.h4, {
        id: "fewer-records-in-iterable-than-synced",
        children: "Fewer records in Iterable than synced"
      }), "\n", _jsx(_components.p, {
        children: "If you see a discrepancy between the number of records that have passed through your sync and the number of records displaying in Iterable, check your data set for duplicates. Iterable automatically dedupes records based on primary key so the number of records in Iterable might be less than the number of records in your Hightouch sync if your sync unintentionally contains duplicates."
      }), "\n", "\n", _jsx(_components.h4, {
        id: "413---request-entity-too-large",
        children: "413 - Request Entity Too Large"
      }), "\n", _jsx(_components.p, {
        children: "If you see this error or notice that your syncs are slow, you can try lowering the batch size in your sync configuration."
      }), "\n", _jsx(_components.h4, {
        id: "400---request-does-not-have-the-same-data-types-as-the-data-previously-submitted",
        children: "400 - Request does not have the same data types as the data previously submitted"
      }), "\n", "\n", _jsx(_components.p, {
        children: "The full error message looks something like this:"
      }), "\n", _jsx(_components.pre, {
        children: _jsxs(_components.code, {
          className: "hljs language-json",
          children: [_jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"msg\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"Project 13691: The request does not have the same data types as the data previously submitted, or the input value is not within the correct range. Field 'date_field' already exists for type 'user' and has a data type of 'date' but possible types 'string, keyword' in the request.\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"code\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"RequestFieldsTypesMismatched\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n  ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"params\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), "\n    ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), "\n      ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"validationErrors\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), "\n        ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), "\n          ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"date_field\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "{"
          }), "\n              ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"incomingTypes\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "["
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"string\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"keyword\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "]"
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n              ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"expectedType\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"date\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n              ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"category\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"user\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n              ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"offendingValue\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "["
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"2023-04-19 12:15:30\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"0000-00-00 00:00:00\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "]"
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ","
          }), "\n              ", _jsx(_components.span, {
            className: "hljs-attr",
            children: "\"_type\""
          }), _jsx(_components.span, {
            className: "hljs-punctuation",
            children: ":"
          }), _jsx(_components.span, {
            className: "hljs-string",
            children: "\"UnexpectedType\""
          }), "\n            ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n        ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n    ", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n", _jsx(_components.span, {
            className: "hljs-punctuation",
            children: "}"
          }), "\n"]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["The first value in the ", _jsx(_components.code, {
          children: "offendingValue"
        }), " array is associated with the first record in the batch sent to Iterable. The second value in the array is the value causing the issue. One instance of this value (", _jsx(_components.code, {
          children: "\"0000-00-00 00:00:00\""
        }), ") causes the entire batch of records being sent to Iterable to fail."]
      }), "\n", _jsxs(_components.p, {
        children: ["To resolve the error, check for instances of (", _jsx(_components.code, {
          children: "\"0000-00-00 00:00:00\""
        }), ") in the ", _jsx(_components.code, {
          children: "date_field"
        }), " column of your model and replace these values with ", _jsx(_components.code, {
          children: "null"
        }), " or a valid date."]
      }), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
